// const ClassicEditor = require('@ckeditor/ckeditor5-build-classic')
// import CKEditor from 'ckeditor4';
export default {
  name: 'wysiwyg',
  ui: {
    textarea: '[js-wysiwyg-textarea]',
  },
  componentDidMount () {
    // CKEditor.replace( 'activity' );
    /* ClassicEditor.create(this.ui.textarea).catch(error => {
      console.error(error)
    }) */
    // console.log('CKEDITOR ...')
    // ClassicEditor.create(this.ui.textarea, {
    //   removePlugins: ['Blockquote', 'Image', 'ImageToolbar'],
    //   toolbar: [
    //     'heading',
    //     '|',
    //     'bold',
    //     'italic',
    //     'underline',
    //     'linethrough',
    //     'link',
    //     'unlink',
    //     'bulletedList',
    //     'numberedList',
    //     '|',
    //     'undo',
    //     'redo',
    //   ],
    // })
  },
}
